import Interceptor from "@/plugins/interceptor.js"

const urlAPI = `${process.env.VUE_APP_API_URL_ACTION}${process.env.VUE_APP_API_ACTION}`

let intervalUserIsInGame = null;
const Action = {
  state: {
  },
  actions: {
    gameEnter: async (_, model) => {
      try {
        const response = await Interceptor.post(`${urlAPI}/gameEnter`, model)
        return response
      } catch (error) {
        console.error(error)
      }
    },
    gameLeave: async (_, model) => {
      try {
        const response = await Interceptor.post(`${urlAPI}/gameLeave`, model)
        return response
      } catch (error) {
        console.error(error)
      }
    },
    waveFlags: async (_, model) => {
      try {
        const response = await Interceptor.post(`${urlAPI}/waveFlags`, model)
        return response
      } catch (error) {
        console.error(error)
      }
    },
    voteSurvey: async (_, model) => {
      try {
        const response = await Interceptor.post(`${urlAPI}/voteSurvey`, model)
        return response
      } catch (error) {
        console.error(error)
      }
    },
    throwPapers: async (_, model) => {
      try {
        const response = await Interceptor.post(`${urlAPI}/throwPapers`, model)
        return response
      } catch (error) {
        console.error(error)
      }
    },
    sendPicture: async (_, model) => {
      try {
        const response = await Interceptor.post(`${urlAPI}/sendPicture`, model)
        return response
      } catch (error) {
        console.error(error)        
      }
    },
    userIsInGame: async (_, model) => {
      async function callUserIsInGame() { 
        const response = await Interceptor.post(`${urlAPI}/userIsInGame`, model)
        return response
      }

      // Verify interval clean
      if (intervalUserIsInGame != null) {
        try {
          clearInterval(intervalUserIsInGame)
          intervalUserIsInGame = null
        } catch (error) {
          console.error(error)
        }
      }

      // First call (without await)
      callUserIsInGame()

      try {
        intervalUserIsInGame = setInterval(async () => {
          await callUserIsInGame()
        }, 60000)
      } catch (error) {
        console.error(error)
      }
    },
    destroyUserIsInGame: () => {
      clearInterval(intervalUserIsInGame)
    },
    registerTicket: async (_, model) => {
      try {
        const response = await Interceptor.post(`${urlAPI}/registerTicket`, model)
        return response
      } catch (error) {
        console.error(error)        
      }
    }
  },
  mutations: {
  }
}

export default Action